import Lucide from "src/base-components/Lucide";
import { buildFourStopGradient, WebsiteThemePreset } from "src/themes/presets";

interface ThemeCardProps {
  preset: WebsiteThemePreset;
  isActive: boolean;
  onSelect: (themeId: string) => void;
}

const ThemeCard = ({ preset, isActive, onSelect }: ThemeCardProps) => {
  const gradient = buildFourStopGradient(preset.colors, "135deg");

  return (
    <button
      type="button"
      onClick={() => onSelect(preset.id)}
      className={`group w-full overflow-hidden rounded-xl border text-left transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_16px_32px_-20px_rgba(0,0,0,0.75)] focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/70 ${
        isActive
          ? "border-sky-400/80 shadow-[0_0_0_1px_rgba(56,189,248,0.45)]"
          : "border-white/10 hover:border-white/20"
      }`}
    >
      <div className="relative px-3 py-5" style={{ background: gradient }}>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.16),transparent_55%)]" />
        <div className="relative space-y-2.5">
          <p className="text-center text-xs font-medium text-white/95 drop-shadow">
            Welcome to TravoTera
          </p>
          <div
            className="mx-auto w-fit rounded-md px-3 py-1.5 text-[10px] font-semibold text-white shadow"
            style={{ backgroundColor: preset.primary }}
          >
            Primary Button
          </div>
        </div>

        {isActive ? (
          <span className="absolute left-2 top-2 rounded-full bg-black/40 px-2 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-amber-300">
            Current
          </span>
        ) : null}

        {isActive ? (
          <span className="absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-white/20">
            <Lucide icon="Check" className="h-3 w-3 text-white" />
          </span>
        ) : null}

        {preset.badge === "recommended" && !isActive ? (
          <span className="absolute right-2 top-2 rounded-full bg-emerald-500/90 px-1.5 py-0.5 text-[9px] font-semibold text-white">
            Recommended
          </span>
        ) : null}
      </div>

      <div className="space-y-2.5 bg-[#171923] px-3 py-3">
        <h3 className="truncate text-sm font-semibold text-white">
          {preset.name}
        </h3>

        <div className="flex gap-1.5">
          {preset.colors.map((color, index) => (
            <span
              key={`${preset.id}-${index}-${color}`}
              title={color}
              className="h-7 flex-1 rounded-md border border-white/15"
              style={{ backgroundColor: color }}
            />
          ))}
        </div>

        <div className="flex gap-1 overflow-hidden">
          {preset.colors.map((color, index) => (
            <span
              key={`${preset.id}-hex-${index}`}
              className="min-w-0 flex-1 truncate text-center text-[9px] font-medium text-slate-400"
            >
              {color}
            </span>
          ))}
        </div>
      </div>
    </button>
  );
};

export default ThemeCard;
